import { render, staticRenderFns } from "./joinBulletFrame.vue?vue&type=template&id=f13363f0&scoped=true&"
import script from "./joinBulletFrame.vue?vue&type=script&lang=js&"
export * from "./joinBulletFrame.vue?vue&type=script&lang=js&"
import style0 from "./joinBulletFrame.vue?vue&type=style&index=0&id=f13363f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13363f0",
  null
  
)

export default component.exports